import { useMemo } from "react"

import { Button, Flex, Typography } from "antd"
import classname from "classname"
import { useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import { useVampHistoricalDataMode } from "../../hooks/useHistoricalDataMode"
import { useEnrollmentModal } from "../EnrollmentModal/hooks/useEnrollmentModal"

import styles from "./VampBlockedBanner.module.less"

const { Text } = Typography

const VampUnenrolledBanner = () => {
  const { isHistoricalDataAvailable, switchToHistoricalDataMode } = useVampHistoricalDataMode()
  const { open } = useEnrollmentModal()
  return (
    <Flex vertical align="center" className={classname(styles.banner, styles.unenrolledBanner)}>
      <Icon type="stats_bar_chart" className={styles.bannerIcon} />
      <Text className={styles.bannerTitle}>Enroll in VAMP to access this feature</Text>
      <Text type="secondary" className={styles.bannerDesc}>
        After enrolling, data will not appear immediately. It usually takes 3 to 7 days for the
        first data to show up in the dashboard.
      </Text>
      <Flex gap={12}>
        {isHistoricalDataAvailable && (
          <Button className={styles.bannerButton} onClick={switchToHistoricalDataMode}>
            View historical data
          </Button>
        )}
        <Button className={styles.bannerButton} type="primary" onClick={open}>
          Enroll in VAMP
        </Button>
      </Flex>
    </Flex>
  )
}

const VampInProgressBanner = () => {
  return (
    <Flex vertical align="center" className={classname(styles.banner, styles.inProgressBanner)}>
      <div className={styles.loader} />
      <Text className={styles.bannerTitle}>Enrollment request submitted</Text>
      <Text type="secondary" className={styles.bannerDesc}>
        Our team is reviewing your request and will submit it to Visa on your behalf. We'll email
        you once enrollment is confirmed. The first data usually appears 3 to 7 days after that.
      </Text>
      <div className={styles.pendingTag}>
        <Icon type="loader" className={styles.pendingTagIcon} />
        <span className={styles.pendingTagText}>Pending...</span>
      </div>
    </Flex>
  )
}

const banners = {
  vamp_unenrolled: <VampUnenrolledBanner />,
  vamp_in_progress: <VampInProgressBanner />
}

const VampBlockedBanner = () => {
  const { enrollmentData } = useSelector((state) => state.health)
  const { isHistoricalDataMode } = useVampHistoricalDataMode()
  const type = useMemo(() => {
    if (!enrollmentData) return null
    if (isHistoricalDataMode) return null
    if (enrollmentData.is_pending_data) return "vamp_in_progress"
    if (!enrollmentData.is_vamp_available) return "vamp_unenrolled"
    return null
  }, [enrollmentData, isHistoricalDataMode])
  const banner = banners[type]

  if (!banner) return null

  return (
    <div className={styles.bannerMask}>
      <div className={styles.content} style={{ top: "32px" }}>
        {banner}
      </div>
    </div>
  )
}

export default VampBlockedBanner
